module.exports = __webpack_public_path__ + "img/BD.ad61fa79.svg";